import { Button } from "@design-system/components/Button";
import { trans } from "@mongez/localization";
import { money } from "@core/shared/utils";
import { paymentAtom } from "../atoms";
import { useFawryPayment } from "../hooks/use-fawry-payment";

export function FawryPayment() {
  const {
    isLoading,
    isInitialized,
    submitted,
    paymentFees,
    totalAmount,
    handleCheckout,
  } = useFawryPayment();

  const paymentMethod = paymentAtom.use("paymentMethod");

  const isCardPayment = paymentMethod === "card";

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <div className="text-center">
          <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-gray-600 dark:text-gray-300">
            {trans("checkout.initializingPayment")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div
        className={`rounded-lg border border-gray-200 dark:border-gray-700 p-4 ${
          isCardPayment ? "bg-blue-50 dark:bg-blue-900/20" : "bg-gray-50 dark:bg-gray-800/50"
        }`}
      >
        <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
          {isCardPayment
            ? trans("checkout.cardPayment")
            : trans("checkout.paymentSummary")}
        </h3>

        {isCardPayment && (
          <div className="mb-4 text-sm text-gray-600 dark:text-gray-300">
            {trans("checkout.cardPaymentDescription")}
          </div>
        )}

        <div className="space-y-3">
          <div className="flex justify-between">
            <span className="text-gray-600 dark:text-gray-300">
              {trans("checkout.paymentFees")}
            </span>
            <span className="font-semibold text-gray-900 dark:text-gray-100">{money(paymentFees)}</span>
          </div>

          <div className="flex justify-between border-t border-gray-200 dark:border-gray-600 pt-3">
            <span className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              {trans("checkout.totalAmount")}
            </span>
            <span className="text-lg font-bold text-primary">
              {money(totalAmount)}
            </span>
          </div>
        </div>
      </div>

      <Button
        onClick={handleCheckout}
        disabled={!isInitialized || !totalAmount || submitted}
        isLoading={submitted}
        className="w-full"
        size="lg"
      >
        {submitted
          ? trans("checkout.processing")
          : isCardPayment
            ? trans("checkout.proceedToCardPayment")
            : trans("checkout.proceedToPayment")}
      </Button>

      {submitted && (
        <div className="text-center text-sm text-gray-600 dark:text-gray-300">
          {trans("checkout.redirectingToPayment")}
        </div>
      )}
    </div>
  );
}
